export const pageImageConfig = {
  home: {
    hero: 'https://i.postimg.cc/KzcJMKJf/Chat-GPT-Image-Jan-19-2026-08-20-36-PM.png',
    training: 'https://i.postimg.cc/HnXcsXv4/Chat-GPT-Image-Jan-19-2026-08-25-00-PM.png',
    about: 'https://i.postimg.cc/hjnN5BWB/Chat-GPT-Image-Jan-19-2026-08-30-31-PM.png',
    finalCta: 'https://i.postimg.cc/mr9tSQBs/Silhouette-of-victorious-athlete-with-arms-raised-in-celebration-on-sports-field-at-golden-hour-suns.jpg'
  },
  about: {
    hero: 'https://i.postimg.cc/VvdsG7Nq/Chat-GPT-Image-Jan-20-2026-12-21-45-PM.png',
    whoWeAre: 'https://i.postimg.cc/8C2qQtw0/Chat-GPT-Image-Jan-20-2026-12-23-28-PM.png'
  },
  locations: {
    hero: 'https://i.postimg.cc/QMC52Kq4/Chat-GPT-Image-Jan-20-2026-01-08-17-PM.png'
  },
  contact: {
    hero: 'https://i.postimg.cc/4ykm2ndG/Chat-GPT-Image-Jan-21-2026-04-44-10-PM.png'
  },
  packages: {},
  booking: {},
  'sofia-mladost': {
    hero: 'https://i.postimg.cc/sXk9sVnG/Chat-GPT-Image-Jan-21-2026-05-22-47-PM.png',
    about: 'https://i.postimg.cc/52bgX2fX/Chat-GPT-Image-Jan-21-2026-05-22-55-PM.png'
  },
  'sofia-nsa': {
    hero: 'https://i.postimg.cc/8cnFNwkM/Chat-GPT-Image-Jan-21-2026-05-32-27-PM.png',
    about: 'https://i.postimg.cc/6304zdv1/Chat-GPT-Image-Jan-22-2026-08-40-08-PM.png'
  },
  plovdiv: {
    hero: 'https://i.postimg.cc/qqZt4QBc/Chat-GPT-Image-Jan-21-2026-05-32-34-PM.png',
    about: 'https://i.postimg.cc/5tZnNq0G/Chat-GPT-Image-Jan-21-2026-05-32-37-PM.png'
  },
  'sofia-boyana': {
    hero: 'https://i.postimg.cc/qqfK31H3/Chat-GPT-Image-Jan-21-2026-05-50-00-PM.png',
    about: 'https://i.postimg.cc/rmV3LNP5/Chat-GPT-Image-Jan-21-2026-05-55-51-PM.png'
  },
  kranevo: {
    hero: 'https://i.postimg.cc/Hx0MbQYt/Chat-GPT-Image-Jan-21-2026-06-02-20-PM.png',
    about: 'https://i.postimg.cc/7LGMJGJS/Chat-GPT-Image-Jan-21-2026-06-02-29-PM.png'
  }
};
